(function(angular) {
    THF.Angular.LiveQuoteTool.directive('tooltipster', ['$parse', function($parse) {
        return {
            restrict: 'A',
            scope: {
                tooltipsterTitle: '=',
                tooltipsterOptions: "="
            },
            link: function(scope, element, attrs) {
                var tooltipsterOptions = scope.tooltipsterOptions || {};
                var message = scope.tooltipsterTitle;
                scope.$watch('tooltipsterTitle', function(value) {
                    element.tooltipster('content', value);
                    if (!value) {
                        element.tooltipster('disable');
                    } else {
                        element.tooltipster('enable');
                    }
                });

                tooltipsterOptions.content = message;
                element.tooltipster(tooltipsterOptions);

                scope.$on("$destroy", function () {
                    element.tooltipster('destroy');
                })
            }
        }
    }]);
})(angular);